// removed by extract-text-webpack-plugin
module.exports = {"progress-indicator-container":"ProgressIndicator__progress-indicator-container","progressIndicatorContainer":"ProgressIndicator__progress-indicator-container","info-container":"ProgressIndicator__info-container","infoContainer":"ProgressIndicator__info-container","title":"ProgressIndicator__title","pagination":"ProgressIndicator__pagination","outer-bar":"ProgressIndicator__outer-bar","outerBar":"ProgressIndicator__outer-bar","inner-bar":"ProgressIndicator__inner-bar","innerBar":"ProgressIndicator__inner-bar"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/ProgressIndicator/ProgressIndicator.scss
// module id = 1802
// module chunks = 8